import { instance } from '@/libs/api/instance'

/**
 * Create card wallet
 *
 * @param {Object} data
 * @param {string} [data.currencyId] - Currency code (e.g. "EUR", "GBP"). Defaults to EUR if omitted.
 * @param {string} [data.description] - Wallet name. Optional.
 * @param {string} [data.color] - Hex color for the wallet label. Optional.
 * @param {number} [data.isVisible] - 0 or 1. Optional.
 * @return {Promise<AxiosResponse<any>>}
 */
export const create = (data) => {
  return instance.post('/v1/wallet', data)
}
